import { Fragment, useState } from 'react'
import type { Immagine } from '../../guida/tipi.ts'
import { IconaImmagine } from '../../componenti/Icone.tsx'

/** Testo della guida: `**parola**` in grassetto, tutto il resto com'e'. */
export function Testo({ t }: { t: string }) {
  const pezzi = t.split('**')
  return <>{pezzi.map((p, i) => (i % 2 ? <strong key={i}>{p}</strong> : <Fragment key={i}>{p}</Fragment>))}</>
}

/** Lo stesso testo senza i segni del grassetto, per gli elenchi e i titoli delle schede. */
export const testoPiano = (t: string) => t.replaceAll('**', '')

/**
 * Cattura di una pagina, da public/guida/. Si carica solo quando arriva a schermo (`loading="lazy"`):
 * la guida ne ha molte e chi apre un capitolo dal telefono non deve scaricarle tutte. Le immagini
 * ancora da fare, o che non si caricano, lasciano un riquadro con la descrizione.
 */
export function Figura({ immagine }: { immagine: Immagine }) {
  const [mancante, setMancante] = useState(!!immagine.daFare)
  const src = `/guida/${immagine.file}`
  if (mancante) {
    return (
      <figure className="guida-figura guida-figura-da-fare">
        <div className="guida-segnaposto" role="img" aria-label={`Immagine in preparazione: ${immagine.descrizione}`}>
          <IconaImmagine />
          <span>Immagine in preparazione</span>
        </div>
        <figcaption>{immagine.descrizione}</figcaption>
      </figure>
    )
  }
  return (
    <figure className="guida-figura">
      {/* Un clic apre la cattura a grandezza piena, per leggere i dettagli. */}
      <a href={src} target="_blank" rel="noopener noreferrer">
        <img src={src} alt={immagine.descrizione} loading="lazy" decoding="async"
             width={immagine.larghezza} height={immagine.altezza} onError={() => setMancante(true)} />
      </a>
      <figcaption>{immagine.descrizione}</figcaption>
    </figure>
  )
}
